import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    flowType: 'pkce',
  },
})

export async function getUser() {
  const { data: { user } } = await supabase.auth.getUser()
  return user
}

export async function getCompany(userId) {
  if (!userId) return null
  const { data, error } = await supabase
    .from('profiles')
    .select('company_id')
    .eq('id', userId)
    .maybeSingle()
  if (error || !data?.company_id) return null
  const { data: company } = await supabase
    .from('companies')
    .select('*')
    .eq('id', data.company_id)
    .maybeSingle()
  return company
}

export async function getRole(userId) {
  if (!userId) return null
  const { data, error } = await supabase
    .from('profiles')
    .select('role')
    .eq('id', userId)
    .maybeSingle()
  if (error) return null
  return data?.role || 'founder'
}
